// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"styles_buttonsContainer__96q_o","buttonsFirstRow":"styles_buttonsFirstRow__118eV","buttonsSecondRow":"styles_buttonsSecondRow__ujH9c"};